import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { ComposeComponent } from '../compose/compose.component';
import { UserService } from '@app/_core/services/user.service';
import { QueuesService } from '@app/_core/services/queues.service';
import { ManagerService } from '@app/_core/services/manager.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Utils } from '@app/_core/helper/Utils';
import { ParseFlags } from '@angular/compiler';
@Component({
  selector: 'app-communication-history',
  templateUrl: './communication-history.component.html',
  styleUrl: './communication-history.component.scss',
})
export class CommunicationHistoryComponent implements OnInit {
  @Input() ReadOnly:any;
  modalRef?: BsModalRef;
  CommunicationHistoryDetail: any[];
  getFaxDetail: any;
  getFaxDetailwithAllFile: any[];
  historyList: any[];
  recipient: any;
  sent: any;
  collapseAll: boolean = false;
  showGetfaxAll: boolean = false;
  selectedRecordingValue: any;
  blobUrl: string | null = null;
  safeUrl: SafeResourceUrl;
  imageSrc: SafeResourceUrl;
  imageSrcJpeg: SafeResourceUrl;
  Status: any;
  fileName: any;
  CarrierMemberId: any;
  CommunicationType = [
    { name: 'All', label: 'All', type: 1 },
    { name: 'Fax', label: 'Fax', type: 2 },
    { name: 'Email', label: 'Email', type: 3 },
  ];
  getCommunicationTypeHistory: any;
  CommunicationTypeHistory = [
    { name: Date.now, label: 'All' },
    { name: Date.now, label: 'Fax' },
    { name: Date.now, label: 'Email' },
  ];

  CommunicationDirection = [
    { name: 'Both', label: 'Both', type: 1 },
    { name: 'Inbound', label: 'Inbound', type: 1 },
    { name: 'Outbound', label: 'Outbound', type: 2 },
  ];
  ngOnInit() {
    // this.CarrierMemberId = '000336659';
    // this.CallCustomMethod();
    this.GetCommunicationHistorySilent();

    this.getCommunicationTypeHistory = setInterval(() => {
      this.GetCommunicationHistorySilent();
    }, 15000); // Refresh every 15 seconds
    // this.GetFax(116);
  }
  constructor(
    public bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private userService: UserService,
    private queueService: QueuesService,
    private managerService: ManagerService,
    private sanitizer: DomSanitizer,
    private utils: Utils
  ) {}

  goCompose() {
    const config: ModalOptions = { class: 'compose-menu' };

    this.modalRef = this.modalService.show(ComposeComponent, config);
    //this.modalRef.content.event.subscribe((result: any) => {});
  }
  closeTask() {
    this.safeUrl = false;
    this.imageSrc = false;
    this.imageSrcJpeg = false;
  }
  GetCommunicationHistorySilent() {
    this.queueService.GetCommunicationHistorySilent().subscribe(response => {
      if (response.Response.Data.length >= 1) {
        this.CommunicationHistoryDetail = response.Response.Data;
        this.recipient = this.CommunicationHistoryDetail[0].Recipient;
        this.sent = this.CommunicationHistoryDetail[0].Sent;
      }
    });
  }
  selectItemid: number | null = null;
  selectItem(ID: number): void {
    this.selectItemid = ID;
    this.GetFax(ID);
  }
  GetFax(ID: number) {
    this.selectItemid = ID;
    this.queueService.GetFax(ID).subscribe(response => {
     // console.log('Data:', response.Response?.Data);

     // console.log('Is Array:', Array.isArray(response.Response?.Data));

      const data = response.Response?.Data;
      if (response.Response?.Data) {
        this.getFaxDetail = response.Response.Data;
        this.getFaxDetailwithAllFile = response.Response.Data.Files;
       // console.log(this.getFaxDetailwithAllFile.length);
        if (this.getFaxDetail.Success == true) {
          this.Status = 'Success';
          this.getFaxDetail.Success = this.Status;
        } else {
          this.Status = 'Pending';
          this.getFaxDetail.Success = this.Status;
        }
        this.showGetfaxAll = true;

       // console.log(this.getFaxDetail);
      } else {
        this.showGetfaxAll = false;
      }
    });
  }

  getFilesDetails(Data: any) {
    let binaryData = '';
   // console.log(Data);
    this.selectedRecordingValue = Data;
    this.managerService.getRecordingFiles(this.selectedRecordingValue).subscribe(data => {
    //  console.log(data);
      if (data.MimeType == 'application/pdf') {
        binaryData = 'data:application/pdf;base64,' + data.result;
        const binary = Utils.convertDataURIToBinary(binaryData);
        const blob = new Blob([binary], { type: data.MimeType });
        this.blobUrl = URL.createObjectURL(blob);
        this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.blobUrl);
      }

      if (data.MimeType == 'text/plain') {
        this.fileName = data.fileName;
        binaryData = 'data:text/plain;base64,' + data.result;
        const binary = Utils.convertDataURIToBinary(binaryData);
        const blob = new Blob([binary], { type: data.MimeType });
        this.blobUrl = URL.createObjectURL(blob);
        this.downloadFile(blob, this.fileName, data.minType);
      }
      if (data.MimeType == 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
        this.fileName = data.fileName;
        binaryData =
          'data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,' + data.result;
        const binary = Utils.convertDataURIToBinary(binaryData);
        const blob = new Blob([binary], { type: data.MimeType });
        this.blobUrl = URL.createObjectURL(blob);
        this.downloadFile(blob, this.fileName, data.minType);
      }
      if (data.MimeType == 'image/png') {
        this.fileName = data.fileName;
        binaryData = 'data:image/png;base64,' + data.result;
        const binary = Utils.convertDataURIToBinary(binaryData);
        const blob = new Blob([binary], { type: data.MimeType });
        this.blobUrl = URL.createObjectURL(blob);
        this.imageSrc = this.blobUrl;
      }
      if (data.MimeType == 'image/jpeg') {
        this.fileName = data.fileName;
        binaryData = 'data:image/jpeg;base64,' + data.result;
        const binary = Utils.convertDataURIToBinary(binaryData);
        const blob = new Blob([binary], { type: data.MimeType });
        this.blobUrl = URL.createObjectURL(blob);
        this.imageSrcJpeg = this.blobUrl;
      }
    });
  }

  downloadFile(blob: Blob, fileName: string, minType: string) {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName || 'downloaded_file';
    link.type = minType;
    link.click();
    URL.revokeObjectURL(link.href);
  }

  CallCustomMethod() {
    this.queueService.CallCustomMethod(this.CarrierMemberId).subscribe(response => {
      if (response?.Response?.Data?.length >= 1) {
        // this.CommunicationHistoryDetail = response.Response.Data;
        // this.recipient = this.CommunicationHistoryDetail[0].Recipient;
        // this.sent = this.CommunicationHistoryDetail[0].Sent;
      }
    });
  }
}
